// interacSuccessStyles.js
import styled from 'styled-components';

/* Layout */
export const Page = styled.div`
  min-height: 100vh;
  background: #f9fafb; /* gray-50 */
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 0.5rem; /* h-2 */
  background: #e5e7eb; /* gray-200 */
`;

export const ProgressFill = styled.div`
  width: 100%;
  height: 100%;
  background: #a3e635; /* lime-400 */
`;

export const Container = styled.div`
  max-width: 48rem; /* ~max-w-3xl */
  margin: 0 auto;
  padding: 1rem;
  font-family: 'Graphik', Helvetica Neue, Helvetica, Arial, sans-serif;

  @media (min-width: 640px) {
    padding: 1.5rem; /* sm:p-6 */
  }

  @media print {
    font-family: 'Graphik', Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
`;

/* Header success icon + titles */
export const Center = styled.div`
  text-align: center;
`;

export const SuccessIconRing = styled.div`
  margin: 0 auto 1.5rem auto;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 3rem;
    height: 3rem;
    color: #16a34a; /* lime-600 */
    @media (min-width: 640px) {
      width: 3.5rem;
      height: 3.5rem;
    }
  }
`;

export const Title = styled.h1`
  margin: 0 0 0.5rem 0;
  color: #231F20;
  font-weight: 600;
  font-size: 32px;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #231F20; /* gray-600 */
  font-weight: 400;
  font-size: 1rem; /* text-base */
  @media (min-width: 640px) {
    font-size: 1.125rem;
  } /* sm:text-lg */
`;

/* Card */
export const DCard = styled.div`
  background: #ffffff;
  border: 1px solid #007c10;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  margin-bottom: 32px;

  @media print {
    margin-bottom: 0;
  }
`;

export const DCardBody = styled.div`
  padding: 1.5rem;

  @media (min-width: 640px) {
    padding: 2rem;
  }
`;

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #231F20;
    margin: 0;
  }
`;

/* Transaction rows */
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e8eef1; /* lime-200 */

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    border-top: 1px solid #e8eef1; /* lime-200 */
  }
`;

export const LabelText = styled.span`
  color: #231f20;
  font-weight: 500;
  font-size: 16px;
`;

export const ValueText = styled.span`
  color: #231f20;
  font-size: 16px;
  font-weight: 500;
  text-align: right;
`;

export const Breakable = styled(ValueText)`
  word-break: break-word;
`;

/* Buttons */
export const ButtonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 9999px;
  font-weight: 700;
  color: #fff;
  background: #005d1f;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 12px 18px -4px rgba(0, 0, 0, 0.12),
      0 6px 8px -3px rgba(0, 0, 0, 0.06);
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  background: transparent;
  border: 1px solid #065f46; /* green-800 */
  color: #065f46;
  cursor: pointer;

  &:hover {
    background: #f0fdf4;
  } /* green-50 */

  svg {
    width: 1rem;
    height: 1rem;
  }
`;
